<div class="tituloPantalla">
    <mat-toolbar style="height: 33px;" fxLayout class="tituloPantalla">
        <h3 class="title">Tareas</h3>
    </mat-toolbar>
</div>

        <form [formGroup]="group" class="a-example-full-width-alterno-content" style="margin: 0px !important; padding: 4vh 4vh;">
            <div class="a-example-full-width-alterno-content-column-2">

                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content">
                        <div class="a-example-full-width-alterno-content">
                            <p-floatLabel class="w-full md:w-56" variant="on">
                                <input pInputText class="w-full md:w-56"
                                    formControlName="desctarea" appendTo="body" />
                                <label for="on_label">Descripcion tarea</label>
                            </p-floatLabel>
                        </div>
                    </div>
                </div>


                <div class="a-example-full-width-alterno-content-row" >

                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="fechaInicio" (onSelect)="onDateChangeDesde($event,'fechaInicio')"
                                appendTo="body" [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                dateFormat="dd/mm/yy">
                            </p-datepicker>
                            <label for="on_label">Fecha Inicio</label>
                        </p-floatLabel>
                    </div>

                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="fechaFin" (onSelect)="onDateChangeDesde($event,'fechaInicio')"
                                appendTo="body" [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                dateFormat="dd/mm/yy">
                            </p-datepicker>
                            <label for="on_label">Fecha Fin</label>
                        </p-floatLabel>
                    </div>
                </div>   

                <div class="a-example-full-width-alterno-content-row" >

                    <div class="a-example-full-width-alterno-content">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-select [options]="ListaEstadosProyecto"
                                placeholder="‎ " optionLabel="nombre" formControlName="estado" optionValue="codigo"
                                appendTo="body" styleClass="w-full md:w-56">
                            </p-select>
                            <label for="on_label">Estado</label>
                        </p-floatLabel>
                    </div>
                    
                </div>   

                <div class="a-example-full-width-alterno-content-row" >
                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-select [options]="listarRecurso"
                                placeholder="‎ " optionLabel="usuA_Nombres" formControlName="recurso" optionValue="usuA_CodUsr"
                                appendTo="body" styleClass="w-full md:w-56" (onChange)="mostrarDats($event)">
                            </p-select>
                            <label for="on_label">Recurso</label>
                        </p-floatLabel>
                    </div>
                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-select [options]="listarImportancia"
                                placeholder="‎ " optionLabel="nombre" formControlName="importancia" optionValue="codigo"
                                appendTo="body" styleClass="w-full md:w-56">
                            </p-select>
                            <label for="on_label">Importancia</label>
                        </p-floatLabel>
                    </div>
                </div>

                <div class="a-example-full-width-alterno-content-row" >
                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-inputNumber styleClass="w-full md:w-56"
                                formControlName="dias" mode="decimal" [showButtons]="true"
                                [useGrouping]="false" [inputStyle]="{'width':'100%'}">
                            </p-inputNumber>
                            <label for="on_label">Días</label>
                        </p-floatLabel>
                    </div>
                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="horas"
                                appendTo="body" [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                [timeOnly]="true" >
                            </p-datepicker>
                            <label for="on_label">Horas</label>
                        </p-floatLabel>
                    </div>
                </div>

                <div class="a-example-full-width-alterno-content-row" >
                    <div class="a-example-full-width-alterno-content-2" *ngIf="!modo">
                        <div class="a-example-full-width-alterno-content" style="display: flex; justify-content: center;">                            
                            <p-button   class="button-width" (click)="guardarTarea()" severity="info" label="Guardar"></p-button>
                        </div>
                    </div>
                    <div class="a-example-full-width-alterno-content-2" *ngIf="modo">
                        <div class="a-example-full-width-alterno-content" style="display: flex; justify-content: center;">                            
                            <p-button  class="button-width" (click)="actualizarTarea()" severity="info" label="Actualizar"></p-button>
                        </div>
                    </div>
                    <div class="a-example-full-width-alterno-content-2" >
                        <div class="a-example-full-width-alterno-content" style="display: flex; justify-content: center;">                            
                            <p-button class="button-width" (click)="salir()" severity="info" label="Cancelar"></p-button>
                        </div>
                    </div>
                </div>


            </div>
                
        </form>

        <style>
            .p-inputtext {
             width: 100%;
            }
            
            ::ng-deep .p-calendar {
                width: 100%;
                /* height: 47px; */
            }
            /* .button-width{
                width: 100%;
            } */
        
            .button-width{
                width: 100%;
                display: flex;
                justify-content: center;
                
            }
            ::ng-deep .p-button{
                width: 50%;
                margin: auto;
            }
            :host ::ng-deep .p-dropdown {
                width: 100%;
                /* height: 47px; */
            }

            :host ::ng-deep .p-inputnumber {
        width: 100%;
    }

    :host ::ng-deep p-inputnumber,
    .p-inputnumber {
        width: 100%;
    }
        
        </style>